import script from "./AttendancesCalendar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AttendancesCalendar.vue?vue&type=script&lang=ts&setup=true"

import "./AttendancesCalendar.vue?vue&type=style&index=0&id=ab832f0c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab832f0c"]])

export default __exports__